import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async find({ dispatch }, gr1tamanho) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.get(`/Products/Sizes/Find/${gr1tamanho}`)
				.then(response => {
					let gr1 = Utils.ValidateAxiosResponse(response.data)
					return gr1
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findGr1descByGr1tamanho({ dispatch }, gr1tamanho) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando", indeterminate: true },
				{ root: true },
			)
			let payload = await dispatch("find", gr1tamanho)
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ dispatch }, gr1){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/Products/Sizes/Update", gr1 )
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
	},
}
